<mulan-button 
    [ngClass]="{'safari': factorySer.isSafari}"
    [fill]="fill" 
    role="button"
    [attr.aria-label]="format? (label | acpText) : label"
    [attr.tabindex]="disabled ? -1 : 0"
    [attr.aria-disabled]="disabled"
    theme="primary" 
    debounceClick 
    [disabled]="disabled" 
    [toastControl]="toastControl"
    [debounceTime]="debounceTime" 
    (debounceClick)="btnAction()">
    {{format? (label | acpText) : label}} 
</mulan-button>